import { useMemo } from "react";

import { useLanguage } from "../../../../../i18n/useLanguage";
import { useTireResults } from "../../useTireResults";
import { useTireCategories } from "./useTireCategories";

type CategoryOption = {
  checked: boolean;
  name: string;
  value: string;
};

export const useTireCategoryOptions = (): CategoryOption[] => {
  const { data: results } = useTireResults();
  const [language] = useLanguage();
  const [selectedTags] = useTireCategories();

  const tags = useMemo(
    () =>
      Object.values(results?.metatagList ?? {})
        .map(({ tag_id, tag_text, tag_text_fr }) => ({
          checked: selectedTags.includes(tag_id),
          name: language === "fr" ? tag_text_fr : tag_text,
          value: tag_id,
        }))
        .sort((a, b) => a.name.localeCompare(b.name)),
    [results, selectedTags.join(",")]
  );

  return tags;
};
